import React from 'react'
import { connect } from 'react-redux'

import Badge from 'components/Badge'
import NavTab from 'components/NavTab'
import MainNavigationBar from 'components/MainNavigationBar'
import BottomNavigation, { BottomNavigationPlaceholder } from 'components/BottomNavigation'
import { AppState } from 'store/types'

import { createStyles, WithStyles, withStyles, Tabs, Tab, AppBar, Hidden, Theme } from '@material-ui/core'
import { Route, withRouter, RouteComponentProps } from 'react-router'

import backgroundUrl from 'assets/images/background.jpg'
import CenteredContent from 'components/CenteredContent'

type Tab = {
  url: string
  title: React.ReactNode
  badgeContent?: React.ReactNode
  component?: React.ComponentType<{}>
}

interface Props {
  tabs: Array<Tab>
}

const tabHeight = 48

const styles = (theme: Theme) => createStyles({
  root: {
    backgroundImage: `url(${backgroundUrl})`,
    backgroundPosition: 'bottom center',
    backgroundSize: 'cover',
    backgroundColor: theme.palette.accent.main,
    display: 'block',
  },
  tabs: {
    height: tabHeight,
  },
  tab: {
    minWidth: 'auto',
    color: '#fff',
    flex: 1,
  },
  tabBadge: {
    padding: `0 ${theme.spacing() * 2}px`,
  },
})

const mapStateToProps = ({ session }: AppState) => ({
  counters: session.user?.info?.counters,
})

type InjectedProps = Props & RouteComponentProps<{}> & ReturnType<typeof mapStateToProps> & WithStyles<typeof styles>

const MainLayout: React.SFC<InjectedProps> = ({
  classes,
  tabs,
  location,
  counters,
}) => (
  <>
    <AppBar position="sticky" className={classes.root}>
      <MainNavigationBar />
      <CenteredContent>
        <Tabs
          variant="fullWidth"
          className={classes.tabs}
          value={location.pathname}
          textColor="inherit"
          indicatorColor="primary"
        >
          {tabs.map(({ title, url, badgeContent }, i) => {
            const label = badgeContent
              ? (
                <Badge color="primary" className={classes.tabBadge} badgeContent={badgeContent}>
                  {title}
                </Badge>
              )
              : title

            return (
              <NavTab key={i} label={label} to={url} value={url} className={classes.tab} replace />
            )
          })}
        </Tabs>
      </CenteredContent>
    </AppBar>
    <CenteredContent>
      {tabs.map(({ url, component }, i) => (
        <Route exact key={i} path={url} component={component} />
      ))}
    </CenteredContent>
    <Hidden smUp>
      <BottomNavigationPlaceholder />
      <BottomNavigation fixed counters={counters} />
    </Hidden>
  </>
)

export default connect(mapStateToProps)(withStyles(styles)(withRouter(MainLayout)))
try {
    // @ts-ignore
    MainLayout.displayName = "MainLayout";
    // @ts-ignore
    MainLayout.__docgenInfo = { "description": "", "displayName": "MainLayout", "props": { "classes": { "defaultValue": null, "description": "Override or extend the styles applied to the component.", "name": "classes", "required": false, "type": { "name": "Partial<Record<\"root\" | \"tab\" | \"tabs\" | \"tabBadge\", string>>" } }, "innerRef": { "defaultValue": null, "description": "", "name": "innerRef", "required": false, "type": { "name": "Ref<any>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/MainLayout/MainLayout.tsx#MainLayout"] = { docgenInfo: MainLayout.__docgenInfo, name: "MainLayout", path: "src/components/MainLayout/MainLayout.tsx#MainLayout" };
}
catch (__react_docgen_typescript_loader_error) { }